import type { SharedFlash } from '@/types/shared'

interface FlashBannerProps {
  flash?: SharedFlash
}

export function FlashBanner({ flash }: FlashBannerProps) {
  if (!flash?.alert && !flash?.notice) {return null}

  const isAlert = Boolean(flash.alert)
  return (
    <div
      className={
        isAlert
          ? 'border-b border-border bg-destructive/10 px-10 py-3 text-center font-sans text-[13px] text-destructive'
          : 'border-b border-border bg-primary/10 px-10 py-3 text-center font-sans text-[13px] text-primary'
      }
    >
      {flash.alert ?? flash.notice}
    </div>
  )
}
